<template>
  <div 
    :id="'question-' + question.id"
    :class="[
      'p-6 rounded-lg border-2 transition-all duration-200',
      isAnswered ? 'bg-white border-green-200' : 'bg-red-50 border-red-200'
    ]"
  >
    <!-- 题目标题 -->
    <div class="flex items-start justify-between mb-4">
      <div class="flex-1">
        <div class="flex items-center gap-3 mb-2">
          <span class="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold text-xs text-gray-700 border-gray-300">
            {{ questionNumber }}
          </span>
          <span 
            v-if="question.required"
            class="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold text-xs bg-red-500 text-white border-red-500"
          >
            必答
          </span>
        </div>
        <h3 class="text-base font-medium text-gray-900 leading-relaxed">
          {{ question.text }}
        </h3>
      </div>
    </div>

    <!-- 选项 -->
    <div class="grid gap-2 mt-4">
      <div class="grid grid-cols-1 gap-3 sm:gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5">
        <label
          v-for="option in options"
          :key="option.value"
          :class="[
            'flex items-center p-2 sm:p-3 rounded-lg border-2 transition-all duration-200 cursor-pointer select-none active:scale-[0.98]',
            answer === option.value
              ? 'bg-psychology-primary/10 border-psychology-primary'
              : 'bg-white/30 border-gray-300 hover:border-gray-400 hover:bg-white/50'
          ]"
        >
          <input
            type="radio"
            :name="question.id"
            :value="option.value"
            :checked="answer === option.value"
            @change="handleAnswer(option.value)"
            class="h-4 w-4 text-psychology-primary focus:ring-psychology-primary shrink-0"
          />
          <span class="ml-2 sm:ml-3 text-xs sm:text-sm font-medium flex-1 leading-tight">
            {{ option.label }}
          </span>
        </label>
      </div>
    </div>

    <!-- 未回答提示 -->
    <div v-if="!isAnswered && question.required" class="flex items-center gap-2 mt-3 text-red-600">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="12"></line>
        <line x1="12" x2="12.01" y1="16" y2="16"></line>
      </svg>
      <span class="text-sm">此题为必答题</span>
    </div>
  </div>
</template>

<script>
import { optionsConfig } from '../../data/questions.js'

export default {
  name: 'QuestionCard',
  props: {
    question: {
      type: Object,
      required: true
    },
    questionNumber: {
      type: Number,
      required: true
    },
    answer: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    options() {
      return optionsConfig[this.question.type] || optionsConfig.likert
    },
    isAnswered() {
      return this.answer !== undefined
    }
  },
  methods: {
    handleAnswer(value) {
      this.$emit('answer', {
        questionId: this.question.id,
        value: value
      })
    }
  }
}
</script>

